import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "conversation-wrapper new-conversation" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", { class: "me-1" }, [
  /*#__PURE__*/_createTextVNode("From:"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "me-auto ms-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center" }
const _hoisted_8 = { class: "me-1 d-block d-md-none" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", { class: "me-1 text-nowrap" }, [
  /*#__PURE__*/_createTextVNode("To: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = { class: "ms-4 w-100" }
const _hoisted_13 = { class: "d-flex w-100 align-items-baseline group-name" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", {
  class: "me-1 ps-3",
  style: {"white-space":"nowrap"}
}, [
  /*#__PURE__*/_createTextVNode("Subject: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group w-100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("section", { class: "conversation-body" }, [
  /*#__PURE__*/_createCommentVNode(" DO NOT DELETE THIS SECTION ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_MessageInputHandler = _resolveComponent("MessageInputHandler")!
  const _directive_alphanumeric_special_only = _resolveDirective("alphanumeric-special-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            name: "weekday-range",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.careTeam) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.groupTypeEnum), ([key, value]) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                (_ctx.hasGroupPermission(value.value))
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: value.value
                    }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.careTeam]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.routeBacktoConnect && _ctx.routeBacktoConnect(...args)))
          }, _hoisted_10)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_TypeaheadInput, {
            placeholder: "Start Patient Name",
            getData: _ctx.getPatientList,
            value: _ctx.patient,
            onValueChanged: _ctx.updatePatient,
            isForMessaging: true,
            focusOnInput: "true",
            tabindex: "1"
          }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conversationSubject) = $event)),
            placeholder: "Enter Thread Subject",
            maxlength: "250",
            tabindex: "2"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, _ctx.conversationSubject],
            [_directive_alphanumeric_special_only]
          ])
        ])
      ])
    ]),
    _hoisted_16,
    _createElementVNode("footer", {
      class: _normalizeClass(["conversation-input", { 'highlight-important': _ctx.newMessage.isImportant }])
    }, [
      _createVNode(_component_MessageInputHandler, {
        send: _ctx.sendMessage,
        "toggle-important": _ctx.toggleImportant,
        "refs-name": `threadEditorRef-${Math.random()}`,
        "should-disable-send": _ctx.disableSend,
        isFamilyPortal: true
      }, null, 8 /* PROPS */, ["send", "toggle-important", "refs-name", "should-disable-send"])
    ], 2 /* CLASS */)
  ]))
}